/* eslint-disable no-nested-ternary */
import React from "react";

import { Grid, Skeleton } from "@mui/material";
import { usePreferenciasV2 } from "services/api";
import { formatarEmReais } from "utils/formatReais";
import { RootStateOrAny, useSelector } from "react-redux";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import PreferenciasDoLeadForm from "../preferenciasDoLeadForm";
import SkeletonPreferencias from "./components/Skeleton";

type FormRowProps = {
  isDataLoading: boolean;
  data: [
    { title: string; subtitle: string },
    { title: string; subtitle: string }
  ];
};

function FormRow({ data, isDataLoading }: FormRowProps) {
  return (
    <>
      <Grid item xs={4}>
        <Styles.ContainerDadosComp>
          <p>{data[0]?.title}</p>
          {isDataLoading ? (
            <Skeleton variant="rounded" width="100px" height={20} />
          ) : (
            <p>{data[0]?.subtitle}</p>
          )}
        </Styles.ContainerDadosComp>
      </Grid>
      <Grid item xs={4}>
        <Styles.ContainerDadosComp>
          <p>{data ? data[1]?.title : "--"}</p>
          {isDataLoading ? (
            <Skeleton variant="rounded" width="100px" height={20} />
          ) : (
            <p>{data[1]?.subtitle}</p>
          )}
        </Styles.ContainerDadosComp>
      </Grid>
    </>
  );
}

interface Props {
  closeModal: Function;
  idLeadCorretor: string;
  refetchDataLead: () => void;
  readOnly?: boolean;
}

export function PreferenciasDoLead(props: Props) {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const showForm = isCorretor || props.readOnly;
  const {
    data: preferenciasLead,
    refetch: refetchPreferenciasLead,
    isRefetching: isRefetchingPreferenciasLead,
    isFetched,
  } = usePreferenciasV2({
    idLeadCorretor: props?.idLeadCorretor,
    queryKey: "dados-complementares-lead-detail",
  });

  React.useEffect(() => {
    refetchPreferenciasLead();
  }, []);

  let zonaFormatted = "";
  if (preferenciasLead?.zonaImovel) {
    if (preferenciasLead?.zonaImovel?.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < preferenciasLead?.zonaImovel?.length; i++) {
        zonaFormatted += preferenciasLead?.zonaImovel[i]?.nome;

        if (i < preferenciasLead?.zonaImovel?.length - 1) {
          zonaFormatted += ", ";
        } else {
          zonaFormatted += ".";
        }
      }
    }
  }

  let bairroFormatted = "";
  if (preferenciasLead?.bairroImovel) {
    if (preferenciasLead?.bairroImovel?.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < preferenciasLead?.bairroImovel?.length; i++) {
        bairroFormatted += preferenciasLead?.bairroImovel[i]?.nome;

        if (i < preferenciasLead?.bairroImovel?.length - 1) {
          bairroFormatted += ", ";
        } else {
          bairroFormatted += ".";
        }
      }
    }
  }

  return (
    <div style={{ padding: "0 1.5rem" }}>
      <Styles.SubTitleInfo>
        Você pode incrementar mais informações para o seu lead, isso te ajudará
        a fazer uma gestão mais personalizada para cada lead
      </Styles.SubTitleInfo>

      {showForm ? (
        !isFetched || isRefetchingPreferenciasLead ? (
          <SkeletonPreferencias />
        ) : isFetched ? (
          <PreferenciasDoLeadForm
            closeModal={() => {
              props?.closeModal();
              refetchPreferenciasLead();
            }}
            idLeadCorretor={props?.idLeadCorretor}
            preferenciasLead={preferenciasLead || undefined}
            refetch={() => refetchPreferenciasLead()}
            refetchDataLead={() => props.refetchDataLead()}
            readOnly={props.readOnly}
          />
        ) : null
      ) : (
        <Grid container spacing={1}>
          <Grid container item spacing={20}>
            <FormRow
              isDataLoading={isRefetchingPreferenciasLead}
              data={[
                {
                  title: "Tipo de empreendimento",
                  subtitle: preferenciasLead?.tipoEmpreendimento || "--",
                },
                {
                  title: "Prazo de entrega",
                  subtitle: preferenciasLead?.prazoEntregaImovel || "--",
                },
              ]}
            />
          </Grid>
          <Grid container item spacing={20}>
            <FormRow
              isDataLoading={isRefetchingPreferenciasLead}
              data={[
                {
                  title: "Metragem",
                  subtitle: preferenciasLead?.inicioIntervaloMetragemImovel
                    ? `${preferenciasLead?.inicioIntervaloMetragemImovel}m² à ${preferenciasLead?.fimIntervaloMetragemImovel}m²`
                    : "--",
                },
                {
                  title: "Valor do imóvel",
                  subtitle: preferenciasLead?.fimIntervaloValorImovel
                    ? `${formatarEmReais(
                        preferenciasLead?.inicioIntervaloValorImovel
                      )} à ${formatarEmReais(
                        preferenciasLead?.fimIntervaloValorImovel
                      )}`
                    : "--",
                },
              ]}
            />
          </Grid>
          <Grid container item spacing={20}>
            <FormRow
              isDataLoading={isRefetchingPreferenciasLead}
              data={[
                {
                  title: "Zona",
                  subtitle: zonaFormatted || "--",
                },
                {
                  title: "Bairro",
                  subtitle: bairroFormatted || "--",
                },
              ]}
            />
          </Grid>
        </Grid>
      )}
      {!showForm ? (
        <Styles.ButtonVoltar
          onClick={() => {
            props.closeModal();
          }}
        >
          Voltar
        </Styles.ButtonVoltar>
      ) : null}
    </div>
  );
}
